var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 9.31853C14.9723 8.91744 14.6323 8.60596 14.2218 8.60596C13.8113 8.60596 13.4713 8.91747 13.4438 9.31853C13.4438 11.3985 12.3109 13.3204 10.472 14.3604C8.63278 15.4003 6.36704 15.4003 4.52786 14.3604C2.68893 13.3203 1.55603 11.3985 1.55603 9.31853C1.52847 8.91744 1.18849 8.60596 0.778015 8.60596C0.367548 8.60596 0.0275343 8.91747 0 9.31853C0.00195113 11.1343 0.689981 12.8853 1.9314 14.2341C3.17281 15.5828 4.87981 16.4337 6.72361 16.6231V18.4759H3.60837C3.19887 18.5029 2.88086 18.8359 2.88086 19.238C2.88086 19.6398 3.1989 19.973 3.60837 20H11.3916C11.8011 19.973 12.1191 19.6398 12.1191 19.238C12.1191 18.8359 11.8011 18.5029 11.3916 18.4759H8.27983V16.6231C10.1229 16.433 11.8292 15.5816 13.0699 14.2328C14.3105 12.8843 14.9981 11.1338 15 9.31853H14.9998Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50038 13.3304C8.61082 13.3295 9.67537 12.8918 10.4604 12.1127C11.2458 11.3339 11.687 10.278 11.688 9.17653V4.15387C11.688 2.66972 10.8899 1.29836 9.59414 0.556537C8.2984 -0.185512 6.7023 -0.185512 5.40657 0.556537C4.11084 1.29842 3.31276 2.66972 3.31276 4.15387V9.16391C3.31008 10.2674 3.75025 11.3269 4.53559 12.1083C5.32117 12.89 6.38766 13.3295 7.50038 13.3304Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic-icon.3a5130328e1e018f26312c44dcf005a4.svg";
export { ForwardRef as ReactComponent };